import { createZoomInBanner } from "@js/utils/zoomInBanner";

document.addEventListener("DOMContentLoaded", () => {
  const zoomInBanner = document.querySelectorAll(
    '.range-banners [data-component="zoom-in-banner"]'
  );
  zoomInBanner.forEach((item) => {
    createZoomInBanner(item);
  });
});
